import $ from "jquery";
export default {
	finalize() {
	}
}